import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomerShoppingInfoModel } from 'app/models/customer-shoppingInfo.model';
import { CalendarTranslate } from '../../../../models/calendarTranslate.model';
import { CalendarTranslateService } from '../../../../modules/UIKit/services/calendarTranslate.service';
import { StoreModel } from './../../../../models/store-common.model';
import { CustomerShoppingInfoService } from './../../../../services/customer/customer-shoppinginfo.service';
import { StoreCommonService } from './../../../../services/store/store-common.service';

declare var $: any;

@Component({
  selector: 'app-customer-shoppinginfo',
  templateUrl: './shoppinginfo.component.html',
})
export class CustomerDetailShoppingInfoComponent implements OnInit {

  @Input() customerId: string;

  calendarTranslate: CalendarTranslate;
  shoppinginfoItems: CustomerShoppingInfoModel[] = [];
  currentList: CustomerShoppingInfoModel;
  mode: string;
  storeInfo: StoreModel;
  productTypes: {}
  productPurchase: {}

  constructor (
    private translate: TranslateService,
    private srvShoppinginfo: CustomerShoppingInfoService,
    private srvCalendarTranslate: CalendarTranslateService,
    private srvStore: StoreCommonService
  ) { }

  ngOnInit(){

    this.initMappings();
    this.mode = "list";

    this.refreshData();
  }

  refreshData(){
    this.shoppinginfoItems = null;
    var self = this;

    setTimeout(function(){

    self.srvShoppinginfo.getShoppingLists(self.customerId).subscribe(res => {
      self.shoppinginfoItems = res;
    });

    },100);

  }

  onClickListDelete(record): void {


    this.srvShoppinginfo.deleteList(record.id).subscribe(() => {

      this.refreshData();
    });

  }

  onClickListDetails(record): void {

    this.currentList = record;

    this.srvStore.get(this.currentList.store_id).subscribe((res) => {
      this.storeInfo = res;
    });

    this.srvShoppinginfo.getListDetails(record.id.toString()).subscribe((res) => {

      for (let product of res) {
        product.item_type = product.item_type != "" ? this.productTypes[product.item_type] : "";
        product.flg_purchased = product.flg_purchased != "" ? this.productPurchase[product.flg_purchased] : "";
      }
      this.currentList.listDetails = res;
      this.mode = "details";
    });

  }

  onClickBack(){
    this.currentList = null;
    this.storeInfo = null;
    this.mode = "list";
  }
  initMappings(){

  this.translate.get(['shoppingList']).subscribe((res) => {

    try{
      this.productTypes = {
        I: res.shoppingList.product,
        C: res.shoppingList.coupon
      }

      this.productPurchase = {
        0: res.shoppingList.no,
        1: res.shoppingList.yes
      }
    }
    catch(e){

      this.productTypes = {
        I: "I",
        C: "C"
      }

      this.productPurchase = {
        0: "0",
        1: "1"
      }
    }

  });


  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/shoppinginfo/shoppinginfo.component.ts